module.exports = __webpack_public_path__ + "static/trends-d59068369c8a6c8b1087d3e540b6e226.jpg";